// REST API Service for Cognixis Landing Page
// This service will be updated with the actual API endpoint after running the deployment script

// Types
export interface StayConnectedData {
  email: string;
}

export interface CareerApplicationData {
  name: string;
  email: string;
  phone?: string;
  resume: string;
  coverLetter?: string;
  position?: string;
}

// Configuration - Update this with your actual API endpoint after running deploy-aws.ps1
const API_BASE_URL = 'https://rk2h4z2jqk.execute-api.us-east-2.amazonaws.com/prod'; // AWS API Gateway endpoint

// API functions
export const apiService = {
  // Subscribe to stay connected
  async subscribeToUpdates(data: StayConnectedData): Promise<any> {
    try {
      
      const response = await fetch(`${API_BASE_URL}/stay-connected`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: data.email
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      throw error;
    }
  },

  // Submit career application
  async submitCareerApplication(data: CareerApplicationData): Promise<any> {
    try {
      
      const response = await fetch(`${API_BASE_URL}/job-applications`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: data.name,
          email: data.email,
          phone: data.phone || '',
          resume: data.resume,
          coverLetter: data.coverLetter || '',
          position: data.position || 'General Application'
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      throw error;
    }
  }
};
